import * as React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import * as identity from '../../utilities/identity';
import { prospectPath, prospectPages } from '../pages/prospect/ProspectRouter';
import { ProspectBasePath } from '../pages/prospect/ProspectRouteValues';

export interface Props extends RouteProps {
    roles?: string[];
}

const AuthorizedRoute = (props: Props) => {
    const role = identity.getMyRole();
    const authenticated = identity.isAuthenticated();
   // const roleValid = props.roles === undefined || !role || props.roles.indexOf(role) !== -1;
   const roleValid =
   props.roles === undefined ||
   (Array.isArray(role)
       ? role.some((r) => props.roles!.includes(r))  
       : props.roles.includes(role!));
    return authenticated && roleValid ? (
        <Route {...props} />
    ) : (
            <Redirect
                to={{
                    pathname:
                        props.path && props.path.includes(ProspectBasePath)
                            ? prospectPath(prospectPages.login)
                            : '/login',
                    state: { from: props.location }
                }}
            />
        );
};

export default AuthorizedRoute;



// WEBPACK FOOTER //
// ./src/components/common/AuthorizedRoute.tsx